export default {"src":"/_next/static/media/arrow-right-white-bg.d157d63b.svg","height":16,"width":18,"blurWidth":0,"blurHeight":0};